import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { queryClient } from "@/services/react-query";

interface LanguageQueryProviderProps {
  children: ReactNode;
}

export const LanguageQueryProvider = ({
  children,
}: LanguageQueryProviderProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLanguageChange = () => {
      queryClient.invalidateQueries();
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return children;
};
